let plt: number | undefined;
let bootCompleted: number | number;
const bootCompletedCallbacks = new Set<(time: number) => void>();

export function setPltValues(newPlt: number | undefined, newBootCompleted: number): void {
    plt = newPlt;
    bootCompleted = newBootCompleted;
    for (const callback of bootCompletedCallbacks) {
        callback(newBootCompleted);
    }
    bootCompletedCallbacks.clear();
}

export function registerForBootCompleted(callback: (time: number) => void): () => void {
    if (bootCompleted !== undefined) {
        callback(bootCompleted);
    } else {
        bootCompletedCallbacks.add(callback);
    }
    return () => bootCompletedCallbacks.delete(callback);
}

// PLT can be undefined if the user was prompted for auth which would make the value invalid
export function getPlt(): number | undefined {
    return plt;
}

// this is the value of boot completed which will always be defined even if the user was
// prompted for auth
export function getBootCompleted(): number {
    return bootCompleted;
}
